<template>
  <div class="d-inline">
    <v-btn color="primary" dark small @click="dialog = true">
      Adicionar Porte
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green darken-2 white--text">
          Adicionar Porte
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="typologySizeForTax.name"
              :rules="requiredRules"
              label="Nome"
              required/>
            <v-checkbox
              v-model="typologySizeForTax.old"
              label="Antigo?"
              required
            />
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="createTypologySizeForTax">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import TypologySizeForTaxService from '@/services/applications/configurations/TypologySizeForTaxService';

import validationRules from '@/mixins/validation-rules';

export default {
  name: 'CreateTypologySizeForTax',
  components: {},
  mixins: [validationRules],
  props: ['typologyId'],
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
      typologySizeForTax: {},
    };
  },
  methods: {
    createTypologySizeForTax() {
      const vm = this;
      TypologySizeForTaxService
        .createTypologySize(vm.typologyId, vm.typologySizeForTax)
        .then((response) => {
          vm.$swal({
            title: 'Porte cadastrado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            const payload = response.data;
            payload.business_table_zones = [];
            vm.$emit('create-typology-size-for-tax', payload);
            vm.closeDialog();
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.typologySizeForTax = {};
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
